import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { OPTIMIZELY_FEATURE_FLAGS_KEYS, PARTNER_MARKETING_OPT_IN } from 'components/Optimizely/Optimizely.features';
import { isFeatureEnabledForUser } from 'components/Optimizely/Optimizely.sdk';

import { reportError } from 'helpers/error-logging';

import { selectUserId } from 'selectors/general';

export function useIsMarketingOptInEnabled() {
  const userId = useSelector(selectUserId);
  const [isMarketingOptInEnabled, setIsMarketingOptInEnabled] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function loadMarketingOptInFlag() {
      try {
        const enabled = await isFeatureEnabledForUser(OPTIMIZELY_FEATURE_FLAGS_KEYS[PARTNER_MARKETING_OPT_IN], userId);

        if (isMounted) setIsMarketingOptInEnabled(enabled);
      } catch (error) {
        reportError('Failed to resolve marketing-opt-in flag', { error, userId });
        if (isMounted) setIsMarketingOptInEnabled(false);
      }
    }

    if (userId) {
      loadMarketingOptInFlag();
    } else {
      setIsMarketingOptInEnabled(false);
    }

    return () => {
      isMounted = false;
    };
  }, [userId]);

  return isMarketingOptInEnabled;
}
